import { Col, Row } from "antd";
import { t } from "i18next";
import React, { useContext } from "react";

import { Button } from "../../../../../components/Button/Button";
import CollapseArrayView from "../../../../../components/CollapseArrayView/CollapseArrayView";
import { ModalsContext } from "../../../../../context/modals.context";
import { IDrustvoInformationMarkiceZahtevProps } from "../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import { AuthorizedPersonsModal } from "./components/AuthorizedPersonsModal/AuthorizedPersonsModal";
import style from "./UserInfo.module.scss";

interface IUserInfoProps {
  exciseStampsInfo: IDrustvoInformationMarkiceZahtevProps;
}

export const UserInfo: React.FC<IUserInfoProps> = ({ exciseStampsInfo }) => {
  const { handleUpdateModals } = useContext(ModalsContext);
  const handleButtonClick = () => {
    handleUpdateModals({ modalVisible: "authorizedPersons" });
  };
  return (
    <Col className={style.mainContainer} span={24}>
      <AuthorizedPersonsModal
        tableData={exciseStampsInfo.ovlascenaLicaZaPreuzimanjeMarkica}
      />
      <Col className={style.title} span={24}>
        {t("AKCIZNE_MARKICE.PODACI_O_PODNOSIOCU_ZAHTEVA")}
      </Col>
      <Row>
        <Col className={`${style.fontSize} mb-25`} span={5}>
          {t("AKCIZNE_MARKICE.NAZIV")}:
        </Col>
        <Col span={5} className={style.fontSize}>
          {exciseStampsInfo.naziv}
        </Col>
        <Col span={5} className={style.fontSize}>
          {" "}
          {t("AKCIZNE_MARKICE.SIFRA_DELATNOSTI")}:
        </Col>
        <Col span={3} className={style.fontSize}>
          {exciseStampsInfo.preteznaDelatnost}
        </Col>
        <Col span={2} className={style.fontSize}>
          <Button
            className={style.button}
            onClick={handleButtonClick}
            type="primary"
          >
            {t("AKCIZNE_MARKICE.SPISAK_OVLASCENIH_LICA_ZA_PREUZIMANJE_MARKICA")}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={5} className={style.fontSize}>
          {" "}
          {t("AKCIZNE_MARKICE.PIB")}:{" "}
        </Col>
        <Col span={5} className={style.fontSize}>
          {exciseStampsInfo.pib}
        </Col>
        <Col className={`${style.fontSize} mb-25`} span={5}>
          {t("AKCIZNE_MARKICE.MESTO_I_ADRESA")}:
        </Col>
        <Col span={5} className={style.fontSize}>
          {`${
            exciseStampsInfo.imeGrada ? `${exciseStampsInfo.imeGrada}, ` : ""
          }${exciseStampsInfo.adresa}`}
        </Col>
      </Row>
      <Row>
        <Col span={5} className={style.fontSize}>
          {" "}
          {t("AKCIZNE_MARKICE.MATICNI_BROJ")}:{" "}
        </Col>
        <Col span={5} className={style.fontSize}>
          {exciseStampsInfo.maticniBroj}
        </Col>
        <Col span={5} className={style.fontSize}>
          {t("AKCIZNE_MARKICE.BROJ_TEKUCEG_RACUNA")}:{" "}
        </Col>
        <Col span={5} className={style.fontSize}>
          {exciseStampsInfo.brojTekucegRacuna
            ?.slice(0, 3)
            ?.map((racun, index) => (
              <Row key={index}>{racun}</Row>
            ))}
          {exciseStampsInfo.brojTekucegRacuna?.slice(3)?.length ? (
            <CollapseArrayView
              elementKey="brojTekucegRacuna"
              items={exciseStampsInfo.brojTekucegRacuna}
            />
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </Col>
  );
};
